import { Link } from "react-router-dom";
import { LOGO_GOLD } from "../../lib/constants";
import { Instagram, Twitter, Youtube, Linkedin } from "lucide-react";

export default function Footer() {
    return (
        <footer className="relative z-10 border-t border-white/10 bg-[#050505] mt-20" data-testid="site-footer">
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid gap-10 md:grid-cols-4">
                <div className="md:col-span-2">
                    <img src={LOGO_GOLD} alt="Digital Beast" className="h-14 mb-5" />
                    <p className="text-white/60 text-sm max-w-md leading-relaxed">
                        Athlete branding, social media management and NIL representation for high school and collegiate football and basketball athletes. Founded by <span className="text-white">Toriano Sanzone</span> & <span className="text-white">Toi Baylor</span>.
                    </p>
                    <div className="flex gap-3 mt-6">
                        {[
                            { Icon: Instagram, name: "instagram" },
                            { Icon: Twitter,   name: "twitter" },
                            { Icon: Youtube,   name: "youtube" },
                            { Icon: Linkedin,  name: "linkedin" },
                        ].map(({ Icon, name }) => (
                            <a key={name} href="#" className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] text-white/60 transition-colors" data-testid={`footer-social-${name}`}>
                                <Icon size={16} />
                            </a>
                        ))}
                    </div>
                </div>
                <div>
                    <div className="section-label mb-5">Platform</div>
                    <ul className="space-y-3 text-sm">
                        {[["Athletes","/athletes"],["Apply","/apply"],["NIL Management","/nil"],["Brands & Sponsors","/brands"],["Academy","/academy"]].map(([l,to]) => (
                            <li key={to}><Link to={to} className="text-white/70 hover:text-[#d4af37] transition-colors">{l}</Link></li>
                        ))}
                    </ul>
                </div>
                <div>
                    <div className="section-label mb-5">Company</div>
                    <ul className="space-y-3 text-sm">
                        {[["About","/about"],["Success Stories","/success-stories"],["Contact","/contact"],["Athlete Login","/login"],["Sponsor Login","/login"]].map(([l,to]) => (
                            <li key={l}><Link to={to} className="text-white/70 hover:text-[#d4af37] transition-colors">{l}</Link></li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
                    <div>© {new Date().getFullYear()} Digital Beast. All rights reserved.</div>
                    <div className="max-w-3xl">
                        Digital Beast is an independent business. Not affiliated with the University of Nebraska, Nebraska Athletics or the Cornhuskers unless a written agreement is secured. Digital Beast does not guarantee scholarships, roster placement, playing time, professional contracts, endorsements or a specific level of NIL income.
                    </div>
                </div>
            </div>
        </footer>
    );
}
